import Logo from '../components/app-plugin-logo';
import NavBar from '../components/app-plugin-navbar';

export default {
  Logo,
  NavBar
}
